module.exports = __webpack_public_path__ + "assets/img/youshi2.f19b1db2.png";